<template>
  <div class="product container">
    <breadcrumbs :breadcrumbs="breadcrumbs" />
    <product-details 
      :product-heading="getPageHeading()"
      :product="this.product"
      :product-properties="productProperties"
      :db-config="dbConfig"
    />
  </div>
</template>

<script>
import {rememberExpiresMixin, headProductMixin} from '@/mixins';
import {DbConfig} from '@/models/db-config';
import {Product, ProductProperty} from '@/models/product';

import Breadcrumbs from '@/components/breadcrumbs';
import ProductDetails from '@/components/catalog/product-details';

export default {
  components: {
    Breadcrumbs,
    ProductDetails,
  },
  mixins: [rememberExpiresMixin, headProductMixin],
  computed: {
    productLocaleData() {
      return this.product?.product_translations?.find(x => x.language.slug === this.$i18n.locale) || {};
    },
    breadcrumbs() {
      let breadcrumbs = [];
      if (this.product.categories && this.product.categories.length) {
        let category = this.product.categories[0];
        let categoryTree = [category];
        while (category.parent) {
          categoryTree.push(category.parent);
          category = category.parent;
        }
        let categoryUrl = '/';
        for (const category of categoryTree.reverse()) {
          categoryUrl += `${category.slug}/`;
          if (category.parent) {
            breadcrumbs.push({
              name: this.getCategoryLocaleData(category).name,
              link: categoryUrl,
            });
          }
        }
      }
      breadcrumbs.push({
        name: this.productLocaleData.name,
      });
      return breadcrumbs;
    },
  },
  async asyncData(context) {
    try {
      const cl = true;
      const [dbConfig, product, productProperties] = await Promise.all([
        DbConfig.config({count_loading: cl}).first(),
        Product.config({count_loading: cl}).find(context.route.params.id),
        ProductProperty.config({count_loading: cl}).get(),
      ]);
      return {
        dbConfig: dbConfig,
        product: product,
        productProperties: productProperties,
      }
    } catch (e) {
      context.error({statusCode: e.response?.status ? e.response.status : 404});
    }
  },
  methods: {
    getPageHeading(){
      let res = this.productLocaleData.name
      if(this.$i18n.locale === 'ru'){
        if(process.env.VENDOR === 'wetz'){
          if(this.propMaker || this.propModel){
            res += ['', 'для', this.propMaker, this.propModel].join(' ')
          }
        }
        else {
          const oems = this.getPropValues('OE-номер')
          if(oems){
            if(Array.isArray(oems))
              res += ' (' + oems.slice(0, 2).join('; ') + ')'
            else
              res += ' (' + oems.split(',').slice(0, 2).join('; ') + ')'
          }
        }
      }
      return res
    },
    getCategoryLocaleData(category) {
      return category.category_translations?.find(x => x.language.slug === this.$i18n.locale) || {};
    },
  },
}
</script>
